function nodeText(node) {
  return node.value || (node.children || []).map(nodeText).join('');
}

// Place support after the final source paragraph or its following source list.
export default function remarkSermonSupport() {
  return (tree) => {
    let position = tree.children.length;
    tree.children.forEach((node, index) => {
      if (!['paragraph', 'heading'].includes(node.type)) return;
      const text = nodeText(node).trim();
      if (!/^(出典|参考文献|参考資料)\s*[:：]?/.test(text)) return;
      position = index + 1;
      if (/^(出典|参考文献|参考資料)\s*[:：]?\s*$/.test(text)) {
        const next = tree.children[position];
        if (next && ['list', 'paragraph'].includes(next.type)) position += 1;
      }
    });
    tree.children.splice(position, 0, {
      type: 'html',
      value: '<div data-sermon-support="true"></div>',
    });
  };
}
